class DateTimeError extends RangeError {
  constructor(code, message) {
    super(message);
    this.name = "DateTimeError";
    this.code = code;
  }
}
export {
  DateTimeError
};
//# sourceMappingURL=errors.js.map
